export default __webpack_public_path__ + "static/media/Filter.ce3ebcff.png";